const message = {
    TotalText: "共",
    ItemText: "条",
    UnnamedColumn: "未命名列",
    EditTable: "编辑表格",
    RestoreDefault: "恢复默认",
    VisibleInfo: "显示的信息",
    HiddenInfo: "隐藏的信息",
    Search: "搜索",
    Cancel: "取消",
    Confirm: "确定",
    View: "查看"
};

export default message;
